import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import React, { Component } from 'react';
import styled from 'styled-components';
import { Stars } from '@ifixit/toolbox';
import { color, fontSize, space } from '@core-ds/primitives';
import { ___p } from '@ifixit/localize';
import ReviewBar from './review_bar';
import ReviewLink from './review_link';
import { Helmet } from 'react-helmet';
var breakpointSm = '@media screen and (max-width: 650px)';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   margin-right: 18px;\n   min-width: 208px;\n   background: #f7f9fa;\n   padding: ", " ", " ", ";\n   border-radius: 4px;\n\n   ", " {\n      margin-right: 0px;\n      width: 100%;\n   }\n"])), space[6], space[5], space[5], breakpointSm);
var ContainerHeader = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   ", " {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n   }\n"])), breakpointSm);
var Aggregate = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   margin: 0 8px;\n   font-size: ", ";\n   font-weight: 700;\n   line-height: 0;\n   color: ", ";\n"])), fontSize['6xl'], color.black);
var AggregateSub = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n   font-weight: normal;\n   font-size: ", ";\n   color: #788188;\n"])), fontSize['4xl']);
var StarsContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n   margin-bottom: 4px;\n"])));
var ReviewCount = styled.h3(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n   margin: 0 0 12px 0;\n   font-weight: normal;\n   font-size: 14px;\n   color: ", ";\n"])), color.gray[800]);

var Visualizer = /*#__PURE__*/function (_Component) {
  _inherits(Visualizer, _Component);

  var _super = _createSuper(Visualizer);

  function Visualizer() {
    _classCallCheck(this, Visualizer);

    return _super.apply(this, arguments);
  }

  _createClass(Visualizer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          productReviews = _this$props.productReviews,
          reviewsUrl = _this$props.reviewsUrl;
      var average = productReviews.average,
          groupedReviews = productReviews.groupedReviews,
          jsonld = productReviews.jsonld;
      var numReviews = productReviews.count;
      return /*#__PURE__*/React.createElement(Container, null, Object.keys(jsonld).length > 0 && /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
        type: "application/ld+json"
      }, JSON.stringify(jsonld))), /*#__PURE__*/React.createElement(ContainerHeader, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Aggregate, null, average), /*#__PURE__*/React.createElement(AggregateSub, null, "/ 5")), /*#__PURE__*/React.createElement(StarsContainer, null, /*#__PURE__*/React.createElement(Stars, {
        rating: average,
        size: 23,
        activeColor: color.lightBlue[600]
      })), /*#__PURE__*/React.createElement(ReviewCount, {
        content: numReviews
      }, ___p(numReviews, '%1 review', '%1 reviews', numReviews))), Object.keys(groupedReviews).sort().map(function (rating) {
        return /*#__PURE__*/React.createElement(ReviewBar, {
          key: "stars-bar-container-".concat(rating),
          index: rating,
          count: groupedReviews[rating],
          numReviews: numReviews
        });
      }).reverse(), reviewsUrl && /*#__PURE__*/React.createElement(ReviewLink, {
        reviewsUrl: reviewsUrl
      }));
    }
  }]);

  return Visualizer;
}(Component);

export default Visualizer;